import { render, staticRenderFns } from "./CollegeInteraction.vue?vue&type=template&id=6a69a70f&scoped=true&lang=html&"
import script from "./CollegeInteraction.vue?vue&type=script&lang=js&"
export * from "./CollegeInteraction.vue?vue&type=script&lang=js&"
import style0 from "./CollegeInteraction.vue?vue&type=style&index=0&id=6a69a70f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a69a70f",
  null
  
)

export default component.exports